module.exports = window.AwesomeQR;


//////////////////
// WEBPACK FOOTER
// external "window.AwesomeQR"
// module id = 1684
// module chunks = 0